import React, { useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Dropdown } from 'semantic-ui-react'
import PropTypes from 'helpers/proptypes'
import { getFormattedAdmins } from 'helpers/admins'
import { getAdmins } from 'redux/entities/selectors'
import { getAdminProfile } from 'redux/reducers/admin/selectors'
import { updateHostApplication } from 'redux/entities/actions'
import { useTranslation } from 'react-i18next'

export function AssignmentDropdown({ hostApplication }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const admins = useSelector(getAdmins)
  const adminProfile = useSelector(getAdminProfile)

  const formattedAdmins = useMemo(
    () => getFormattedAdmins(admins).map(({ key, text }) => ({ text, value: key })),
    [admins],
  )

  function handleAssignCM(_, { value }) {
    const admin = admins.find((admin) => admin.get('id') === value)
    dispatch(
      updateHostApplication(hostApplication.id, {
        followup: {
          user_id: adminProfile.user,
          user_fullname: adminProfile.fullname,
          action: 'assignment',
          actionText: admin.id
            ? t('HostApplications::assigned the application to {{adminName}}', { adminName: admin.fullname })
            : t('HostApplications::removed the assignment'),
        },
        admin: { assignment: { admin_id: admin.get('id'), admin_fullname: admin.get('fullname') } },
      }),
    )
  }

  return (
    <Dropdown
      search
      selection
      options={formattedAdmins}
      onChange={handleAssignCM}
      value={hostApplication.getIn(['admin', 'assignment', 'admin_id'])}
    />
  )
}

AssignmentDropdown.propTypes = {
  hostApplication: PropTypes.immutable.record.isRequired,
}
